const content = {
  getlist: 'content/getlist',
  addDetails: 'content/add-detail',
  updateDetails: 'content/update-detail',
  removeDetails: 'content/remove-detail',
  get: 'content/get',
  getall: 'content/getall',
  remove: 'content/remove',
}
export default content
